import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Popover,
  TextField,
  Typography,
} from "@mui/material";
import { AppLayout } from "layout";
import React from "react";

const FilterCommon = ({
  activeDropdown,
  setActiveDropdown,
  onFilterChange,
  onClearAll,
}: any) => {
  const handleClick = () => {
    setActiveDropdown(1); // 1 is the index for this dropdown
  };

  const handleFilterSelection = (filter: any) => {
    onFilterChange(filter);
    setActiveDropdown(null);
  };

  return (
    <Grid display={"flex"} flexDirection={"column"} position={"relative"}>
      <Box onClick={handleClick} sx={styleSheet.filterContainer}>
        <img src="/assets/icons/afffilter.png" alt="filter" />
        Filter
      </Box>
      {activeDropdown == 1 && (
        <Box sx={styleSheet.boxCon}>
          <Box display={"flex"} flexDirection={"column"} gap={2}>
            <Typography fontSize={"15px"} fontWeight={700} color={"#233F91"}>
              Source of Knowledge
            </Typography>
            {[
              "Scientific Research",
              "Clinical Insights",
              "Lived Experience",
            ].map((filter) => (
              <Typography
                key={filter}
                onClick={() => handleFilterSelection(filter)}
                sx={{
                  cursor: "pointer",
                  fontSize: "17px",
                  fontWeight: 400,
                  color: "#797979",
                }}
              >
                {filter}
              </Typography>
            ))}

            <Box display="flex" alignItems="center" mb={2}>
              <Button
                variant="outlined"
                onClick={() => {
                  onClearAll(); // Trigger clear all
                  setActiveDropdown(null); // Close dropdown
                }}
              >
                Clear
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Grid>
  );
};

export default FilterCommon;

const styleSheet = {
  filterContainer: {
    backgroundColor: "white",
    borderRadius: "15px",
    padding: "10px 8px",
    display: "flex",
    gap: 1,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "17px",
    fontWeight: "400px",
    // width: "93px",
    width: "77px",
    color: "#233F91",
    fontFamily: "Atten Round New",
  },
  boxCon: {
    position: "absolute",
    top: "100%",
    zIndex: 1,
    width: { xs: "100%", md: 223 },
    bgcolor: "background.paper",
    borderRadius: "8px",
    mt: 1,
    p: 2,
  },
};
